import React from 'react';
import LinkRenderer from './LinkRenderer';

const TruncatedTextRenderer = ({ 
  text, 
  links, 
  paragraphClass = 'text-xs',
  forceThreeLines = false 
}) => {
  if (forceThreeLines) {
    // When forcing three lines, render text directly with proper truncation
    return (
      <div className="line-clamp-3 overflow-hidden leading-5 break-words text-sm text-textPrimary min-h-[3.75rem]">
        {text}
      </div>
    );
  }

  // Default behavior - use LinkRenderer for normal cases
  return (
    <LinkRenderer 
      paragraphClass={paragraphClass} 
      text={text} 
      links={links} 
    />
  );
};

export default TruncatedTextRenderer;
